<template>
    <swiper class="banner" ref="swiper" :options="options">
        <swiper-slide v-for="item in config.banner" :key="item.id" :style="`background-image: url(${item.image});`"></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
</template>

<script>
import { mapState } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "detailBanner",
    data() {
        return {
            options: {
                loop: true,
                autoplay: {
                    disableOnInteraction: false,
                },
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                effect : 'fade',
            }
        };
    },
    computed: {
        ...mapState(['config']),
        swiper() {
            return this.$refs.swiper.$swiper
        },
    },
    components: {
        swiper,
        swiperSlide
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.banner{
    width: 100%;
    height: 240px;
    .swiper-slide{
        background-size: cover;
        background-position: center;
    }
}
</style>